// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"674":"b60b4856","2019":"6a93f550","4141":"6a93f550","9236":"78ee9d5e"}[chunkId] + ".chunk.css";
};